
  import { Component, Vue } from 'vue-property-decorator'
  import BackNav from '@/components/BackNav/index.vue'
  import { editStoreInfo } from '@/api/store'
  import { Debounce } from '@/core/decorator'
  import { Getter, Action } from 'vuex-class'
  
  @Component({
    name: 'EditCompanyName',
  })
  export default class EditCompanyName extends Vue {
    @Getter companyId!: string
    @Action setCompanyName!: (companyName: string) => void
    companyName = ''
    errShakeClass = 'animate__animated animate__headShake'
    isShake = false
    isExceed = false

    created() {
      // 从路由参数获取初始值
      this.companyName = (this.$route.query.name as string) || '鲜萃元气养胃精品生鲜店'
    }

    // 计算加权长度（汉字算2字符）
    getWeightedLength(val: string) {
      if (!val) return 0
      return Array.from(val).reduce((count, char) => {
        return count + (/[\u4e00-\u9fa5]/.test(char) ? 2 : 1)
      }, 0)
    }

    mounted() {
      // 聚焦到输入框
      this.$nextTick(() => {
        const inputField = this.$refs.inputField as any
        if (inputField && inputField.$el) {
          const textarea = inputField.$el.querySelector('textarea')
          if (textarea) {
            textarea.focus()
          }
        }
      })
    }
  
    @Debounce(500)
    async onSave() {
      if (this.getWeightedLength(this.companyName) > 100 || !this.companyName.trim()) {
        this.isShake = true
        this.isExceed = true
        setTimeout(() => {
          this.isShake = false
          this.isExceed = false
        }, 1000)
        return
      }
      try {
        const res = await editStoreInfo({
          storeId: this.companyId,
          companyName: this.companyName
        })
        if (res.code === '000000') {
          this.$toast.success('保存成功')
          this.setCompanyName(this.companyName)
          setTimeout(() => {
            this.$router.back()
          }, 1000)
        } else {
          this.$toast.fail(res.msg || '保存失败')
        }
      } catch (e) {
        console.error(e)
        this.$toast.fail('保存失败')
      }
    }
  }
  